import styled from 'styled-components';

const SearchTabStyle = styled.div`
    display: flex;
    flex-direction: row;
`
export default SearchTabStyle;
